import React from "react";
import PropTypes from "prop-types";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import AssetFormTypeProvider from "./forms/form-provider";
import { MultipartNewAssetForm } from "./forms/new-form";

const AssetNewPage = ({ title = "app.page.asset.new", isCommonAsset }) => (
  <Dashboard>
    <PageHeaderBar title={title} />
    <PageSection>
      <AssetFormTypeProvider>
        <MultipartNewAssetForm isCommonAsset={isCommonAsset} defaultCategories={["OTHER"]} />
      </AssetFormTypeProvider>
    </PageSection>
  </Dashboard>
);

AssetNewPage.propTypes = {
  /**
   * Título del form
   */
  title: PropTypes.string,
  /**
   * Indica si estamos subiendo un asset común
   */
  isCommonAsset: PropTypes.bool,
};

export default AssetNewPage;
